import { dateHandler } from '../helpers/helper.js';

const initLogPage = () => {
	dateHandler();

	const container = $('#log-list-container');
	const filterForm = $('#log-filter-form');
	const perPageSelect = $('#log-per-page');
	const tableBody = $('#log-table tbody');
	const paginationContainer = $('#log-pagination');
	const summaryEl = $('#log-results-summary');

	if(!container.length || !filterForm.length || !tableBody.length){
		return;
	}

	const parseJsonData = (value) => {
		if(!value){
			return {};
		}
		try{
			return JSON.parse(value);
		}catch(error){
			return {};
		}
	};

	const labels = parseJsonData(container.attr('data-log-labels'));
	const actions = parseJsonData(container.attr('data-log-actions'));
	const toBool = (value) => value === true || value === 1 || value === '1' || value === 'true';
	let xmlHeader = $('#log-table thead th[data-xml-column]');
	const hasXmlHeader = xmlHeader.length > 0;
	let isSuperAdmin = hasXmlHeader || toBool(container.data('isSuperAdmin'));
	let currentSortBy = container.data('sortBy') || 'logs.date';
	let currentSortDir = container.data('sortDir') || 'desc';
	let requestCounter = 0;
	let activeCancelSource = null;
	const searchDebounceMs = 700;

	const escapeHtml = (value) => $('<div>').text(value == null ? '' : String(value)).html();
	const hasValue = (value) => value !== null && value !== undefined && value !== '';
	const formatDate = (value) => {
		if(!value){
			return '';
		}
		if(value.indexOf('.') !== -1){
			return value;
		}
		const datePart = value.split(' ')[0];
		const parts = datePart.split('-');
		if(parts.length !== 3){
			return value;
		}
		return `${parts[2]}.${parts[1]}.${parts[0]}`;
	};

	const toggleDateRangeVisibility = () => {
		const showRange = $('#typeDate').val() !== 'all';
		const fromGroup = $('#from').closest('.col-md-4');
		const toGroup = $('#to').closest('.col-md-4');
		if(fromGroup.length){
			fromGroup.toggle(showRange);
		}
		if(toGroup.length){
			toGroup.toggle(showRange);
		}
	};

	const restoreDateInputs = () => {
		const typeDateValue = $('#typeDate').val();
		if(!typeDateValue){
			return;
		}
		const shouldDisable = typeDateValue !== 'user defined';
		$('#from').prop('disabled', shouldDisable);
		$('#to').prop('disabled', shouldDisable);
		toggleDateRangeVisibility();
	};

	const buildDetailLines = (items) => {
		return items
			.filter((item) => hasValue(item.value))
			.map((item) => `<strong>${escapeHtml(item.label)}:</strong> ${escapeHtml(item.value)}<br>`)
			.join('');
	};

	const ensureXmlHeader = () => {
		if(xmlHeader.length){
			return;
		}
		const headerRow = $('#log-table thead tr');
		if(!headerRow.length){
			return;
		}
		headerRow.append('<th data-xml-column>XML</th>');
		xmlHeader = $('#log-table thead th[data-xml-column]');
	};

	const toggleXmlColumn = () => {
		if(!isSuperAdmin && hasXmlHeader){
			xmlHeader.hide();
			return;
		}
		if(isSuperAdmin){
			ensureXmlHeader();
		}
		if(xmlHeader.length){
			xmlHeader.toggle(isSuperAdmin);
		}
	};

	const renderLogs = (logs) => {
		if(!Array.isArray(logs)){
			tableBody.empty();
			return;
		}
		let rows = '';
		logs.forEach((log) => {
			const actionConfig = actions[log.action] || {};
			const actionLabel = actionConfig.label || log.action_label || log.action || '';
			const actionClass = actionConfig.class || 'badge badge-violet';
			const actionHtml = `<span class="${actionClass}">${escapeHtml(actionLabel)}</span>`;

			const productDetails = buildDetailLines([
				{label: labels.product, value: log.product_code},
				{label: labels.order, value: log.order_nr},
				{label: labels.customer, value: log.customer},
			]);

			const expirationDate = log.expiration_date ? formatDate(log.expiration_date) : '';
			const batchDetails = buildDetailLines([
				{label: labels.batch, value: log.batch_lot},
				{label: labels.exp, value: expirationDate},
				{label: labels.serial, value: log.serial_number},
				{label: labels.order_number, value: log.logos_order_number},
			]);

			let diffHtml = '';
			if(log.diff_amount !== null && log.diff_amount !== undefined){
				const diffValue = Number(log.diff_amount);
				if(!Number.isNaN(diffValue)){
					diffHtml = `${diffValue >= 0 ? '+' : '-'} ${Math.abs(diffValue)}`;
				}
			}

			rows += '<tr>';
			rows += `<td>${actionHtml}</td>`;
			rows += `<td>${escapeHtml(formatDate(log.date))}</td>`;
			rows += `<td>${productDetails}</td>`;
			rows += `<td>${batchDetails}</td>`;
			rows += `<td>${escapeHtml(diffHtml)}</td>`;
			if(isSuperAdmin){
				const xmlLink = log.xml_url
					? `<a href="${escapeHtml(log.xml_url)}" target="_blank">${escapeHtml(labels.xml_link || 'Link')}</a>`
					: '';
				rows += `<td>${xmlLink}</td>`;
			}
			rows += '</tr>';
		});
		tableBody.html(rows);
	};

	const renderSummary = (pagination) => {
		if(!summaryEl.length){
			return;
		}
		const from = pagination && pagination.from ? pagination.from : 0;
		const to = pagination && pagination.to ? pagination.to : 0;
		const total = pagination && pagination.total ? pagination.total : 0;
		summaryEl.text(`Zeige Zeile ${from} bis ${to} von ${total} Zeilen.`);
	};

	const buildPaginationRange = (current, last, delta = 2) => {
		const range = [];
		const rangeWithDots = [];
		let previous;

		for(let page = 1; page <= last; page++){
			if(page === 1 || page === last || (page >= current - delta && page <= current + delta)){
				range.push(page);
			}
		}

		for(const page of range){
			if(previous){
				if(page - previous === 2){
					rangeWithDots.push(previous + 1);
				}else if(page - previous > 2){
					rangeWithDots.push('...');
				}
			}
			rangeWithDots.push(page);
			previous = page;
		}

		return rangeWithDots;
	};

	const renderPagination = (pagination, baseUrl) => {
		if(!paginationContainer.length){
			return;
		}
		if(!pagination || pagination.last_page <= 1){
			paginationContainer.empty();
			return;
		}

		const current = pagination.current_page;
		const last = pagination.last_page;
		const base = new URL(baseUrl, window.location.origin);
		const buildPageUrl = (page) => {
			const pageUrl = new URL(base.toString());
			if(page <= 1){
				pageUrl.searchParams.delete('page');
			}else{
				pageUrl.searchParams.set('page', page);
			}
			return pageUrl.toString();
		};

		const pages = buildPaginationRange(current, last);
		let html = '<nav><ul class="pagination">';

		const prevDisabled = current <= 1;
		html += `<li class="page-item ${prevDisabled ? 'disabled' : ''}">`;
		html += `<a class="page-link" href="${prevDisabled ? '#' : buildPageUrl(current - 1)}" data-page="${current - 1}" aria-label="Previous">&laquo;</a>`;
		html += '</li>';

		pages.forEach((page) => {
			if(page === '...'){
				html += '<li class="page-item disabled"><span class="page-link">\u2026</span></li>';
				return;
			}
			const isActive = page === current;
			html += `<li class="page-item ${isActive ? 'active' : ''}">`;
			html += `<a class="page-link" href="${buildPageUrl(page)}" data-page="${page}">${page}</a>`;
			html += '</li>';
		});

		const nextDisabled = current >= last;
		html += `<li class="page-item ${nextDisabled ? 'disabled' : ''}">`;
		html += `<a class="page-link" href="${nextDisabled ? '#' : buildPageUrl(current + 1)}" data-page="${current + 1}" aria-label="Next">&raquo;</a>`;
		html += '</li>';

		html += '</ul></nav>';
		paginationContainer.html(html);
	};

	const updateSortLinks = () => {
		container.find('a[data-sort]').each(function(){
			const sortKey = $(this).data('sort');
			const normalizedKey = sortKey === 'date' ? 'logs.date' : sortKey;
			const isCurrent = currentSortBy === normalizedKey;
			let nextDir = 'asc';
			if(sortKey !== 'action_label'){
				nextDir = isCurrent && currentSortDir === 'asc' ? 'desc' : 'asc';
			}
			const url = new URL(window.location.href);
			url.searchParams.set('sort_by', sortKey);
			url.searchParams.set('sort_dir', nextDir);
			$(this).attr('href', url.toString());
		});
	};

	const setValue = (selector, value, triggerChange = false) => {
		const el = $(selector);
		if(!el.length){
			return;
		}
		el.val(value);
		if(triggerChange){
			el.trigger('change');
		}
	};

	const applyFilters = (filters) => {
		if(!filters){
			return;
		}
		if($('#typeDate').length){
			setValue('#typeDate', filters.typeDate || '');
			$('#typeDate').trigger('change');
		}
		setValue('#from', filters.from || '');
		setValue('#to', filters.to || '');
		setValue('#type_log', filters.type_log || '');
		setValue('#product', filters.product || '', true);
		setValue('#order', filters.order || '', true);
		setValue('#supplier', filters.supplier || '', true);
		setValue('#search', filters.search || '');
		if(typeof filters.per_page !== 'undefined'){
			setValue('#log-per-page', String(filters.per_page));
		}
	};

	const fetchLogs = (url, options = {}) => {
		const requestId = ++requestCounter;
		const requestUrl = new URL(url, window.location.origin).toString();

		if(activeCancelSource){
			activeCancelSource.cancel('Newer request');
		}
		const cancelSource = axios.CancelToken.source();
		activeCancelSource = cancelSource;

		axios.get(requestUrl, {
			headers: {'Accept': 'application/json'},
			cancelToken: cancelSource.token
		})
			.then(function(response){
				if(requestId !== requestCounter){
					return;
				}
				const data = response.data || {};
				if(typeof data.is_super_admin !== 'undefined' && !hasXmlHeader){
					isSuperAdmin = toBool(data.is_super_admin);
					container.attr('data-is-super-admin', isSuperAdmin ? 1 : 0);
					toggleXmlColumn();
				}
				renderLogs(data.logs || []);
				renderSummary(data.pagination || {});
				renderPagination(data.pagination || {}, requestUrl);
				if(data.sort){
					currentSortBy = data.sort.by || currentSortBy;
					currentSortDir = data.sort.dir || currentSortDir;
					container.attr('data-sort-by', currentSortBy);
					container.attr('data-sort-dir', currentSortDir);
				}
				applyFilters(data.filters);
				if(!options.skipHistory && window.history){
					if(options.pushState && history.pushState){
						history.pushState({}, '', requestUrl);
					}else if(history.replaceState){
						history.replaceState({}, '', requestUrl);
					}
				}
				updateSortLinks();
			})
			.catch(function(error){
				if(axios.isCancel && axios.isCancel(error)){
					return;
				}
				window.location.href = requestUrl;
			})
			.finally(function(){
				if(activeCancelSource === cancelSource){
					activeCancelSource = null;
				}
			});
	};

	const buildUrlFromForm = (form) => {
		const url = new URL(window.location.href);
		const formData = new FormData(form);
		const activeNames = new Set();

		for(const [name, value] of formData.entries()){
			if(!name){
				continue;
			}
			activeNames.add(name);
			if(value === ''){
				url.searchParams.delete(name);
				continue;
			}
			url.searchParams.set(name, value);
		}

		const fields = form.querySelectorAll('input, select, textarea');
		fields.forEach((field) => {
			if(!field.name){
				return;
			}
			if(activeNames.has(field.name)){
				return;
			}
			url.searchParams.delete(field.name);
		});

		if(url.searchParams.get('sort_by') === 'action_label'){
			url.searchParams.set('sort_dir', 'asc');
		}

		url.searchParams.delete('page');
		return url.toString();
	};

	filterForm.on('submit', function(event){
		event.preventDefault();
		const url = buildUrlFromForm(this);
		restoreDateInputs();
		fetchLogs(url, {pushState: false});
	});

	container.on('click', '[data-reset-form]', function(event){
		event.preventDefault();
		const url = new URL(window.location.href);
		url.search = '';
		fetchLogs(url.toString(), {pushState: false});
	});

	if(perPageSelect.length){
		perPageSelect.on('change', function(){
			const url = new URL(window.location.href);
			if(this.value){
				url.searchParams.set('per_page', this.value);
			}else{
				url.searchParams.delete('per_page');
			}
			url.searchParams.delete('page');
			fetchLogs(url.toString(), {pushState: true});
		});
	}

	$('#typeDate').on('change', function(){
		toggleDateRangeVisibility();
	});

	container.on('click', 'a[data-sort]', function(event){
		event.preventDefault();
		const sortKey = $(this).data('sort');
		const normalizedKey = sortKey === 'date' ? 'logs.date' : sortKey;
		const isCurrent = currentSortBy === normalizedKey;
		let nextDir = 'asc';
		if(sortKey !== 'action_label'){
			nextDir = isCurrent && currentSortDir === 'asc' ? 'desc' : 'asc';
		}
		const url = new URL(window.location.href);
		url.searchParams.set('sort_by', sortKey);
		url.searchParams.set('sort_dir', nextDir);
		fetchLogs(url.toString(), {pushState: true});
	});

	paginationContainer.on('click', 'a[data-page]', function(event){
		event.preventDefault();
		if($(this).closest('.disabled').length){
			return;
		}
		const page = Number($(this).data('page'));
		if(Number.isNaN(page) || page < 1){
			return;
		}
		const url = new URL(window.location.href);
		url.searchParams.set('page', page);
		fetchLogs(url.toString(), {pushState: true});
	});

	window.addEventListener('popstate', function(){
		fetchLogs(window.location.href, {skipHistory: true});
	});

	const initSearchAutoSubmit = () => {
		const form = filterForm.get(0);
		const search = document.getElementById('search');
		if(!form || !search){
			return;
		}

		let timer;
		let isComposing = false;
		let lastValue = search.value;

		const moveCursorToEnd = () => {
			const end = search.value.length;
			search.focus();
			search.setSelectionRange(end, end);
		};
		requestAnimationFrame(moveCursorToEnd);

		const submitForm = () => {
			const value = search.value;
			if(value === lastValue){
				return;
			}
			lastValue = value;
			if(typeof form.requestSubmit === 'function'){
				form.requestSubmit();
			}else{
				filterForm.trigger('submit');
			}
		};

		const scheduleSubmit = () => {
			clearTimeout(timer);
			timer = setTimeout(() => {
				if(!isComposing){
					submitForm();
				}
			}, searchDebounceMs);
		};

		search.addEventListener('input', () => {
			if(isComposing){
				return;
			}
			scheduleSubmit();
		});

		search.addEventListener('compositionstart', () => {
			isComposing = true;
		});

		search.addEventListener('compositionend', () => {
			isComposing = false;
			scheduleSubmit();
		});

		search.addEventListener('keydown', (event) => {
			if(event.key === 'Enter'){
				clearTimeout(timer);
				event.preventDefault();
				submitForm();
			}
		});
	};

	updateSortLinks();
	toggleDateRangeVisibility();
	toggleXmlColumn();
	initSearchAutoSubmit();
};

export default initLogPage;
